'use client';

import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  name?: string;
  label?: string;
}

export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  name,
  label,
}: ToggleSwitchProps) {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (disabled) return;
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        name={name}
        type="button"
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B0D9F7] focus-visible:ring-offset-2 ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        } ${
          checked
            ? 'bg-gradient-to-r from-[#0086E6] to-[#8ABC00]'
            : 'bg-[#EDEDEE] border border-[#B0D9F7]'
        } ${disabled ? 'opacity-80' : ''}`}
      >
        <span
          className={`inline-block h-[15px] w-[15px] transform rounded-full bg-white shadow-[0_1px_3px_rgba(31,47,84,0.14)] transition-transform duration-200 ${
            checked ? 'translate-x-[18px]' : 'translate-x-[3px]'
          }`}
        />
      </button>
      {label && (
        <label className="text-sm text-gray-700 cursor-pointer" onClick={handleClick}>
          {label}
        </label>
      )}
    </div>
  );
}
